export * from './TermAndCopyright'